export const closeButton = {
    position: 'absolute',
    top: '12px',
    right: '18px',
    color: "primary.main"
}

export const backButton = {
    position: 'absolute',
    top: '12px',
    left: '18px',
    color: "primary.main"
}